import React from 'react'

import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { apiFestivosService } from 'services/apiFestivosService';
import { showAppAlert } from "components/common/AppAlerts";

const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const FestivosAccionesRapidas = (props) => {

    let festivosN = []
    const handleFestivosComunes = async () =>{
     props.setLoading(true)
    
     
     try{
            const fetchData = async () =>{
              const url = process.env.PUBLIC_URL + "/assets/json/" + props.anno+ "FestivosAutonomicos.json";
               
          
              await fetch(url) 
              .then(response => response.json())
              .then(data => {
                  festivosN = data.content;
              })
              .catch(error => {
                  showAppAlert("Los festivos aun no estan cargados en el sistema.", "info")
              });
            }
           
            await fetchData();
            for(let i = 0; i < festivosN.length; i++){
              await apiFestivosService.postFestivoCentro(props.centroId, festivosN[i].anno, festivosN[i].mes, festivosN[i].dia);
            }
            
      
            festivosN= [];
          }catch(e){
            console.log(e)
          } finally {
            props.setLoading(false)
            props.handleUpdate()
          }
    }
    const handleFinDeSemana = async () =>{
        props.setLoading(true)
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1); 
          const endDate = new Date(year, 11, 31); 

          await HacerFestivoDiaSemana(startDate,endDate, [0,6])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }


    const handleDomingos = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [0])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }

    const handleLunes = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [1])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }

    const handleMartes = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [2])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }

    const handleMiercoles = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [3])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }

    const handleJueves = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [4])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }

    const handleViernes = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [5])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }
    const handleSabados = async () =>{
        props.setLoading(true)
        
        try{
          const year = props.anno;
          const startDate = new Date(year, 0, 1);
          const endDate = new Date(year, 11, 31);

          await HacerFestivoDiaSemana(startDate,endDate, [6])
        } finally {
          props.setLoading(false)
          props.handleUpdate()
        }
    }




    //daysOfWeek de 0 a 6  (0 Domingo -> 6 Sabado)
    const HacerFestivoDiaSemana = async (startDate, endDate, daysOfWeek) =>{

        for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
            
            if (daysOfWeek.includes(date.getDay())) { 
               await apiFestivosService.postFestivoCentro(props.centroId, date.getFullYear(), meses[date.getMonth()].toUpperCase(), date.getDate())
            }
        }

    }

  return (
    <>
     <Row className="mt-2">
              <Col>
                <Card>
                  <CardBody>
                  <h5>Acciones rápidas:</h5>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleFestivosComunes()}>Festivos comunes</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleFinDeSemana()}>Fin de semana festivo</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleLunes()}>Lunes festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleMartes()}>Martes festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleMiercoles()}>Miercoles festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleJueves()}>Jueves festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleViernes()}>Viernes festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleSabados()}>Sábados festivos</Button>
                  <Button color="primary" className='btn btn-sm' onClick={ () => handleDomingos()}>domingos festivos</Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </>
  )
}

export default FestivosAccionesRapidas
